import React, {useState} from 'react';
import ComponentRegistry from '../registry.js';

export default function NonLinear(props) {
  const [cleanup, setCleanup] = useState(false);
  const [globalData, setGlobalData] = useState({});
  
  const contentData = props.data;
  const moduleIndex = props.controller.getModuleIndex();
  const [currentChoice, setCurrentChoice] = useState(null);
  const [stepIdx, setStepIdx] = useState(-1);
  const [crossingIdx, setCrossingIdx] = useState(0);

  const [data, setData] = useState(null);

  const onCleanup = () => {
    setCleanup(true);
    setTimeout(() => {
      props.controller.stepComplete();
      setCleanup(false);
    }, 400);
  };

  const getStepLinks = () => {
    return contentData.steps.map((n,i) => {
      return <div className={`step-button step-button-${i} ${stepIdx === i ? 'current' : ''}`} onClick={() => {
        setStepIdx(n.id);
        setCurrentChoice(contentData.steps[n.id]);
      }}>
        <h4>{n.truck_type}</h4>
        <p>{n.truck_load}</p>
      </div>
    })
  };

  const incrementCrossingIdx = () => {
    console.log('incrementing IDX')
    let newIdx = crossingIdx+1;
    setCrossingIdx(newIdx);
  }

  const getStepById = id => contentData.steps.filter((step, i) => ((step.id === id) ? step : false));

  const getComponent = id => {
    if (!contentData.steps) {
      return "Invalid JSON format, missing steps property.";
    } else if (!getStepById(id)) {
      return "Invalid step id.";
    }
    setData(getStepById(id)[0]);
  };

  const showComponent = data => {
    const stepTotal = contentData.steps.length;
    return ComponentRegistry(data.type, {
      key: `mod${moduleIndex}-step${data.id}-reset${props.resetIndex}`,
      data: data,
      globalData: globalData,
      setGlobalData: setGlobalData,
      stepId: data.id,
      stepTotal: stepTotal,
      cleanup: cleanup,
      incrementCrossingIdx: incrementCrossingIdx,
      onCleanup: onCleanup,
      onComplete: () => setData(null),
      reset: props.controller.resetStep,
      audioController: props.audioController,
      audioCollection: props.audioCollection,
      scoring: props.scoring,
      setScoring: props.setScoring
    });
  };

  return (
    <div className={`NonLinear ${cleanup ? 'cleanup' : 'not-cleanup'}`}>
      <div className={`container`}>
        {data && showComponent(data)}
        {!data && <div className={`selection-screen`}>
          {stepIdx !== -1 && <div className={`truck`} />}
          <div className={`options`}>
            <h3>Choose Your Truck</h3>
            {getStepLinks()}
          </div>

          {
            stepIdx !== -1 &&
            <div className={`route-info route-info-${stepIdx}`}>
              <div dangerouslySetInnerHTML={{__html:currentChoice.route_info}} />
              <button className={`start-btn`} onClick={() => {
                setData(currentChoice);
              }}>Start Now</button>
              <div className={`map`} />
            </div>
          }

          </div>}
      </div>
    </div>
  )
}